import { render } from "./InfoWithIcon.vue?vue&type=template&id=b33c62f6&scoped=true&ts=true&lang=pug"
import script from "./InfoWithIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoWithIcon.vue?vue&type=script&lang=ts&setup=true"

import "./InfoWithIcon.vue?vue&type=style&index=0&id=b33c62f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33c62f6"]])

export default __exports__